import * as React from 'react'
import { Button } from '@/components/ui/button'
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuGroup,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Locale } from '../../types'

interface IProps {
	locale: Locale
}

const LANGUAGES: Record<Locale, { label: string; flag: string }> = {
	[Locale.EN]: { label: 'English', flag: 'en.svg' },
	[Locale.NL]: { label: 'Dutch', flag: 'nl.svg' },
	[Locale.FR]: { label: 'French', flag: 'fr.svg' },
	[Locale.DE]: { label: 'German', flag: 'de.svg' },
}

const LanguagePicker = ({ locale }: IProps) => {
	const onItemClick = (locale: Locale) => {
		const url = new URL(window.location.toString())
		url.searchParams.set('locale', locale)

		window.location.replace(url.toString())
	}

	return (
		<DropdownMenu>
			<DropdownMenuTrigger
				render={<Button variant="outline" size="default" className="rounded-full" />}
			>
				<img
					src={`/images/flags/${LANGUAGES[locale].flag}`}
					alt=""
					className="size-5 rounded-full"
				/>
				{LANGUAGES[locale].label}
			</DropdownMenuTrigger>

			<DropdownMenuContent align="start" className="min-w-40">
				<DropdownMenuGroup>
					<DropdownMenuLabel>Language</DropdownMenuLabel>

					{Object.entries(LANGUAGES).map(([value, { label, flag }]) => (
						<DropdownMenuItem key={value} onClick={() => onItemClick(value as Locale)}>
							<img src={`/images/flags/${flag}`} alt="" className="size-5 rounded-full" />
							{label}
						</DropdownMenuItem>
					))}
				</DropdownMenuGroup>
			</DropdownMenuContent>
		</DropdownMenu>
	)
}

export default LanguagePicker
